import { createContext, useContext, useState } from "react";


const EmployeFilterContext = createContext()

export const useEmployeFilter = () => {
    return useContext(EmployeFilterContext);
};

export const EmployeFilterProvider = ({ children }) => {
    const [sidebarMenu, setSidebarMenu] = useState("")
    const [selectedEmployee, setSelectedEmployee] = useState({});
    const [badget, setBadget] = useState([]);
    const [ticketComment, setTicketComment] = useState({})


    return (
        <EmployeFilterContext.Provider value={{ selectedEmployee, setSelectedEmployee, sidebarMenu, setSidebarMenu, badget, setBadget, ticketComment, setTicketComment }}>
            {children}
        </EmployeFilterContext.Provider>
    );

}